import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "sendgrid",
  "name": "SendGrid",
  "category": "integrations",
  "description": "Send emails via SendGrid",
  "icon": "siSendgrid",
  "iconType": "simple-icon",
  "color": "blue",
  "version": "1.2.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "SendGrid",
    "color": "#1a82e2"
  },
  "credentials": [
    {
      "name": "sendgridApi",
      "required": true,
      "displayName": "SendGrid API"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "sendgrid",
    "email",
    "send",
    "mail",
    "transactional"
  ]
};

export default definition;
